/**************************************************
 * Nombre:       Tarjeta_Habitaciones_Reserva
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {obtenerNumNoches} from "../../Modulo_Motor_Reservas/Funciones/obtenerNumNoches";
import {obtenerValorReserva} from "../../CodigoNegocio/obtenerValorReserva";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {theme} from "../../Tema";


const Tarjeta_Habitaciones_Reserva = ({item, entidad, seleccionada, setSeleccionada}) => {

    return (
        <Grid
            onClick={() => setSeleccionada(item)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                cursor: 'pointer',
                border: seleccionada.id === item.id ? 2 : 0,
                borderRadius: 3,
                borderColor: theme.palette.primary.main,
            }}

        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <img src={item.img} width={'100%'} height={'auto'} style={{borderRadius: '10px'}}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{p: 1}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                    <Typography sx={{fontSize: 12}}>{`Habitacion #${item.numero}`}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 12}}>{`Numero de Noches: ${obtenerNumNoches({
                        fechaCheckIn: entidad.fechaCheckIn,
                        fechaCheckOut: entidad.fechaCheckOut
                    })}`}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{fontSize: 12}}>{`Total personas: ${entidad.numAcompanantes + entidad.numNinos}`}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{
                        fontSize: 14,
                        fontWeight: 600
                    }}>{`Costo: ${formatoMoneda(obtenerValorReserva({
                        entidad: entidad,
                        habitacion: item,
                        numNoches: obtenerNumNoches({
                            fechaCheckIn: entidad.fechaCheckIn,
                            fechaCheckOut: entidad.fechaCheckOut
                        })
                    }))}`}</Typography>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Habitaciones_Reserva